// src/shims/proj4-setup.ts
import proj4Lib from "proj4";
import "proj4-fully-loaded"; // loads EPSG defs into the same instance

const p: any = (proj4Lib as any).default ?? proj4Lib;

if (typeof p.defs !== "function") {
  const store = p.defs || {};
  p.defs = (name: any, def?: any) => {
    if (typeof name === "string") store[name] = def;
    else Object.assign(store, name);
  };
  p.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");
  p.defs(
    "EPSG:3857",
    "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +no_defs"
  );
}

if (typeof window !== "undefined") (window as any).proj4 = p;
